(function () {
  function initTKCScrollTop() {
    var btn = document.getElementById("tkcScrollTop");
    if (!btn) return;

    // Show once you're past where sticky header appears
    var SHOW_AFTER_PX = 420;

    var ticking = false;

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (y > SHOW_AFTER_PX) {
        btn.classList.add("is-visible");
      } else {
        btn.classList.remove("is-visible");
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    function scrollToTop() {
      try {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } catch (e) {
        window.scrollTo(0, 0);
      }
    }

    btn.addEventListener("click", scrollToTop, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
  }

  // Wait for DOM + let theme boot first
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      // Run after a tick so Impulse can finish sticky init
      setTimeout(initTKCScrollTop, 0);
    });
  } else {
    setTimeout(initTKCScrollTop, 0);
  }
})();
